<template>
  <div class="about">
    <div>
        <v-app-bar app class="px-8" color="#111111" dark flat >
            <!-- <v-spacer></v-spacer> -->
            <v-btn text @click="goTo">About me</v-btn>
            <v-btn text @click="goTo">Quotes</v-btn>
            <v-btn text @click="goTo">Interests</v-btn>
            <v-btn text @click="goTo">Portfolio</v-btn>
            <v-btn text @click="goTo">Blogs</v-btn>
            <v-btn text @click="goTo"> Connect</v-btn>
        </v-app-bar>
    </div>
    <iframe src="https://drive.google.com/file/d/1x3ui9WfcYAPLetj2pMfg1GUxvt8mKDr5/preview" width="100%" height="1000px" />
  </div>
</template>

<script>

export default {

    methods: {
        goTo() {
            this.$router.push('/')
            document.location.reload()
        }
    }
}
</script>
